<template>
  <b-container class="messageInput chat-message-composer">
    <b-form-textarea
      ref="input"
      class="msg-input"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :aria-describedby="describedBy"
      aria-label="Type a message to the AI assistant"
      no-resize
      rows="2"
      max-rows="4"
      @input="onInput"
      @keydown.enter.exact.prevent="onEnter"
      @keydown.shift.enter.exact.prevent="appendNewline"
      @keydown.ctrl.enter.exact="appendNewline"
      @keydown.meta.enter.exact="appendNewline"
    />
    <button
      type="button"
      class="sendBtn"
      :disabled="disabled || sendDisabled"
      aria-label="Send message"
      @click="$emit('send')"
    >
      {{ sendingLabel }}
      <i class="fas fa-paper-plane sendIcon" aria-hidden="true" />
    </button>
  </b-container>
</template>

<script>
/**
 * Input + send — same classes as CurrentMessage.vue (.messageInput, .msg-input, .sendBtn).
 * Compact flex layout for narrow panels. Enter sends; Ctrl/Cmd+Enter inserts a newline.
 */
export default {
  name: 'ChatMessageComposer',
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    sendDisabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Type your message here',
    },
    sendingLabel: {
      type: String,
      default: 'Send',
    },
    describedBy: {
      type: String,
      default: null,
    },
  },
  methods: {
    focus() {
      if (this.$refs.input && typeof this.$refs.input.focus === 'function') {
        this.$refs.input.focus();
      }
    },
    onInput(val) {
      this.$emit('input', val == null ? '' : val);
    },
    onEnter() {
      if (this.disabled || this.sendDisabled) return;
      this.$emit('send');
    },
    appendNewline() {
      if (this.disabled) return;
      this.$emit('input', `${this.value}\n`);
    },
  },
};
</script>

<style scoped>
.messageInput {
  font-size: 17px;
  border-top: 1px solid #ebebeb;
  background-color: white;
  border-radius: 0 0 10px 10px;
  padding: 10px 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px;
}

.msg-input {
  flex: 1 1 auto;
  min-width: 0;
  width: auto !important;
  height: auto !important;
  min-height: 52px;
  box-shadow: unset !important;
  font-size: 17px;
  line-height: 1.4;
  border: unset;
}

.sendBtn {
  color: white;
  background-color: #bd9d5f;
  border: none;
  cursor: pointer;
  padding: 10px 18px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 500;
  flex: 0 0 auto;
  position: static;
  left: auto;
  top: auto;
}

.sendBtn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.sendIcon {
  font-size: 15px;
  margin-left: 4px;
}
</style>
